import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.InstitutionEmploymentEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.InstitutionEmploymentList })));
const create = lazy(() => import("./Create").then(m => ({ default: m.InstitutionEmploymentCreate })));

export default { edit, list, create };
